import { QuestionTypes } from '../models/question.model';
import { File } from '../services/questionnaire/questionnaire.service';

export const isPhotoVideoQuestionType = (questionType: QuestionTypes): boolean => {
  return [QuestionTypes.VideoQuestion, QuestionTypes.PhotoQuestion].includes(questionType);
};
export const isPhotoVideoResultUploaded = (videoPhotoResult: File): boolean => {
  return videoPhotoResult?.fullPath?.includes('amazonaws');
};
